module.exports = __webpack_public_path__ + "img/rba-avions.72cc21c7.jpg";